var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.88 6.02l-.486.122a.5.5 0 00.432.375l.053-.497zm-7.76 0l.054.497a.5.5 0 00.432-.375L4.12 6.02zm8.244-.122A4.502 4.502 0 008 2.5v1a3.502 3.502 0 013.394 2.642l.97-.244zM8 2.5a4.502 4.502 0 00-4.364 3.398l.97.244A3.502 3.502 0 018 3.5v-1zM4.067 5.523A4 4 0 00.5 9.5h1a3 3 0 012.674-2.983l-.107-.994zM.5 9.5a4 4 0 004 4v-1a3 3 0 01-3-3h-1zm4 4h7v-1h-7v1zm10-4a3 3 0 01-3 3v1a4 4 0 004-4h-1zm-2.674-2.983A3 3 0 0114.5 9.5h1a4 4 0 00-3.567-3.977l-.107.994z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.025 7.025A3.5 3.5 0 1111.5 13",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_yun.7ad0a275.svg";
export { SvgTongyongYun as ReactComponent };